import React from 'react';
import engineeringSpecs from '../../data/engineeringSpecs';
import './DesignManufacturing.css';

function DesignManufacturing() {
  const competencies = [
    { name: 'Schematic design', desc: 'Logic-driven multi-sheet schematic authoring.' },
    { name: 'Electrical architecture', desc: 'Topological physical-to-functional wiring synthesis.' },
    { name: 'Harness drawings', desc: 'Production-ready formboard layout engineering.' },
  ];

  const platforms = [
    {
      label: 'CAD platform 01',
      name: 'Zuken E3',
      desc: 'Intelligent, multi-view ECAD environment for complex cabinet and harness design automation.',
    },
    {
      label: 'CAD platform 02',
      name: 'Capital H',
      desc: 'Advanced Siemens suite optimized for model-driven electrical systems architecture.',
    },
  ];

  return (
    <section className="relative bg-cogLight overflow-hidden py-20 lg:py-28 font-sans">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Section Intro */}
        <div className="max-w-2xl mb-14 lg:mb-20">
          <span className="text-sm font-semibold text-cogCyan block mb-3">
            Design &amp; manufacturing
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-[2.5rem] font-bold text-cogBrand tracking-tight leading-[1.15] font-display mb-5">
            Engineering precision from concept to production.
          </h2>
          <p className="text-slate-600 text-base leading-relaxed font-normal">
            Our engineering team delivers intelligent wiring harness design solutions
            that combine advanced software platforms with industry best practices—from
            electrical architecture development to production-ready documentation.
            We support OEMs with accurate, standards-compliant workflows that accelerate
            product development timelines.
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">

          {/* Left Column: Image */}
          <div className="lg:col-span-5 lg:sticky lg:top-8">
            <div className="relative p-1 bg-white border border-slate-200 rounded-sm group">
              <div className="dm-corner-bracket dm-cb-tl" />
              <div className="dm-corner-bracket dm-cb-br" />

              <div className="overflow-hidden bg-cogInk aspect-[4/3] rounded-2xs">
                <img
                  src="/images/designing.webp"
                  alt="Wiring harness design engineering schematic layout"
                  className="w-full h-full object-cover filter contrast-[1.02] saturate-[0.95] group-hover:scale-[1.01] transition-transform duration-500 ease-out opacity-95 group-hover:opacity-100"
                />
              </div>
            </div>
          </div>

          {/* Right Column: Platforms & Competencies */}
          <div className="lg:col-span-7 space-y-14">

            {/* Platform Feature Blocks */}
            <div className="space-y-5">
              <span className="text-sm font-semibold text-slate-400 block">
                Software platforms
              </span>
              <div className="grid sm:grid-cols-2 gap-4">
                {platforms.map((platform) => (
                  <div
                    key={platform.name}
                    className="p-6 bg-white border border-slate-200 rounded-sm hover:border-cogCyan/40 transition-colors duration-200"
                  >
                    <span className="text-xs font-medium text-slate-400 block mb-2">
                      {platform.label}
                    </span>
                    <span className="text-lg font-bold text-cogInk block mb-2">
                      {platform.name}
                    </span>
                    <span className="text-sm text-slate-500 leading-relaxed font-normal block">
                      {platform.desc}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Core Competencies */}
            <div className="space-y-5">
              <span className="text-sm font-semibold text-slate-400 block">
                Core competencies
              </span>
              <ul className="border-t border-slate-200 divide-y divide-slate-200">
                {competencies.map((item) => (
                  <li
                    key={item.name}
                    className="py-5 flex flex-col sm:flex-row sm:items-baseline justify-between gap-1.5 group"
                  >
                    <span className="font-bold text-cogBrand group-hover:text-cogCyan transition-colors duration-150">
                      {item.name}
                    </span>
                    <span className="text-sm text-slate-500 font-normal">
                      {item.desc}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
}

export default DesignManufacturing;